import { render, staticRenderFns } from "./CityDetailUnivercities.vue?vue&type=template&id=a0c2f726&scoped=true&"
import script from "./CityDetailUnivercities.vue?vue&type=script&lang=js&"
export * from "./CityDetailUnivercities.vue?vue&type=script&lang=js&"
import style0 from "./CityDetailUnivercities.vue?vue&type=style&index=0&id=a0c2f726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c2f726",
  null
  
)

export default component.exports